/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_ad__magazine__generic_title = /** @type {(inputs: {}) => string} */ () => {
	return `Auf der Suche nach Inspiration?`
};

const en_ad__magazine__generic_title = /** @type {(inputs: {}) => string} */ () => {
	return `Need inspiration?`
};

const es_ad__magazine__generic_title = /** @type {(inputs: {}) => string} */ () => {
	return `¿Necesitas inspiración?`
};

const fr_ad__magazine__generic_title = /** @type {(inputs: {}) => string} */ () => {
	return `Besoin d'inspiration ?`
};

const it_ad__magazine__generic_title = /** @type {(inputs: {}) => string} */ () => {
	return `Bisogno d'ispirazione`
};

const nl_ad__magazine__generic_title = /** @type {(inputs: {}) => string} */ () => {
	return `Inspiratie nodig?`
};

const pt_ad__magazine__generic_title = /** @type {(inputs: {}) => string} */ () => {
	return `Precisa de inspiração?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ad__magazine__generic_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ad__magazine__generic_title", locale)
	if (locale === "de") return de_ad__magazine__generic_title(inputs)
	if (locale === "en") return en_ad__magazine__generic_title(inputs)
	if (locale === "es") return es_ad__magazine__generic_title(inputs)
	if (locale === "fr") return fr_ad__magazine__generic_title(inputs)
	if (locale === "it") return it_ad__magazine__generic_title(inputs)
	if (locale === "nl") return nl_ad__magazine__generic_title(inputs)
	return pt_ad__magazine__generic_title(inputs)
};